import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import RightSideMenu from './components/rightSideMenu.vue'
import PacientHeader from './components/pacientHeader.vue'
import DropDown from './components/dropdown.vue'
import UploadImgBtn from './components/uploadImgBtn.vue'
import MainModal from './components/mainModal.vue'
import LoadingComponent from './components/loading.vue'
import DeleteTratamentBtn from './components/deleteTratamentButton.vue'
import AddTratamentModal from './components/addTratamentModal.vue'
import Datepicker from 'vuejs-datepicker'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { alpha, email, min, required, confirmed } from 'vee-validate/dist/rules'
// import VueLodash from 'vue-lodash'
import './assets/styles/base.less'
import VueMask from 'v-mask'
import './store/utils'
import { regexValidation } from './mixins/regex-validation';
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// console.log(process.env.NODE_ENV)
process.env.NODE_ENV === 'production' && Sentry.init({
  dsn: "https://ccef33856bc642a2a85584e126cc5598@o476429.ingest.sentry.io/5516524",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

export const EventBus = new Vue()
// Vue.use(VueLodash)
Vue.use(VueMask)
Vue.mixin(regexValidation)
Vue.component('RightSideMenu', RightSideMenu)
Vue.component('PacientHeader', PacientHeader)
Vue.component('MainModal', MainModal)
Vue.component('LoadingComponent', LoadingComponent)
Vue.component('DropDown', DropDown)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Datepicker', Datepicker)
Vue.component('UploadImgBtn', UploadImgBtn)
Vue.component('DeleteTratamentBtn', DeleteTratamentBtn)
Vue.component('AddTratamentModal', AddTratamentModal)
extend('required', {
  ...required,
  message: 'This field is required!'
})
extend('email', email)
extend('alpha', alpha)
extend('min', min)
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Parolele nu coincid'
})
extend('confirmed', confirmed);
/* equal or greather then */
extend('eqOrGt', (value, values) => {
  if (value) {
    return +value >= +values[0]
  }
});
/* equal or greather then panaLa minutes */
extend('eqOrGtMinutes', (value, values) => {
  const deLaOra = +values[0]
  const deLaMinute = +values[1]
  const panaLaOra = +values[2]
  if (value) {
    return panaLaOra === deLaOra
      ? +value >= deLaMinute
      : true
  }
});
/* greather then */
extend('gt', (value, values) => {
  if (value) {
    return +value > +values[0]
  }
});
/* less then */
extend('lt', {
  validate: (value, values) => +value < +values[0],
  message: (value, values) => `The {_field_} field must be less then ${values[0]}`
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
